/**
 * @Date: 2025-02-17 09:57:57
 * @FilePath: /act/src/router/router2025.js
 * @Author: zwy
 * @Description:
 */

const Act2025 = [
  // 爱的克斯
  {
    path: "/itch2025/index",
    name: "itch2025",
    component: (resolve) => require(["@/act2025/itch2025/index.vue"], resolve),
    meta: {
      title: "IT2705全能挑战四维智测定义电源分析新标杆",
    },
  },
  // 测试电容
  {
    path: "/testshouzhi/index",
    name: "testshouzhi",
    component: (resolve) =>
      require(["@/act2025/testshouzhi/index.vue"], resolve),
    meta: {
      title: "测试电容",
    },
  },

  // 慕尼黑
  {
    path: "/munihei20250318/index",
    name: "keysight250217ac",
    component: (resolve) =>
      require(["@/act2025/munihei20250318/index.vue"], resolve),
    meta: {
      title: "慕尼黑上海电子展",
    },
  },
  // 示波器---q2---安诚
  {
    path: "/keysight250217ac/index",
    name: "keysight250217ac",
    component: (resolve) =>
      require(["@/act2025/keysight250217ac/index.vue"], resolve),
    meta: {
      title: "HD3示波器提升电源完整性和动态小电流测试的能力",
    },
  },
  // 示波器---q2---康祺
  {
    path: "/keysight250217kq/index",
    name: "keysight250217kq",
    component: (resolve) =>
      require(["@/act2025/keysight250217kq/index.vue"], resolve),
    meta: {
      title: "HD3示波器让电源测试更精准便捷",
    },
  },
  // 中电港
  {
    path: "/zdg",
    name: "zdg",
    component: (resolve) => require(["@/act2025/zdg250301/zdg.vue"], resolve),
    meta: {
      title: "scrm直播活动定制",
    },
  },
  {
    path: "/zdg250304",
    name: "zdg250304",
    component: (resolve) =>
      require(["@/act2025/zdg250301/zdglive.vue"], resolve),
    meta: {
      title: "scrm直播中问卷",
    },
  },
  // 安森美全年活动
  {
    path: "/onsemi250521/index/:page_identify?",
    name: "onsemi250521",
    component: (resolve) =>
      require(["@/act2025/onsemi250521/index.vue"], resolve),
    meta: {
      title: "探索安森美奥秘，追寻科技火花，点亮未来边界",
    },
  },
  // 示波器---q3---精测
  {
    path: "/keysight250526jc/index",
    name: "keysight250526jc",
    component: (resolve) =>
      require(["@/act2025/keysight250526jc/index.vue"], resolve),
    meta: {
      title: "AI时代的电源和器件测试",
    },
  },
  // 示波器---q3---贝奇
  {
    path: "/keysight250526bq/index",
    name: "keysight250526bq",
    component: (resolve) =>
      require(["@/act2025/keysight250526bq/index.vue"], resolve),
    meta: {
      title: "HD3高精度示波器实现功率器件的精确测量",
    },
  },
  // 罗德
  {
    path: "/Rohde2507/index",
    name: "Rohde2507",
    component: (resolve) => require(["@/act2025/Rohde2507/index.vue"], resolve),
    meta: {
      title: "光速洞察 智测未来",
    },
  },
  // 小视频---q4---康祺
  {
    path: "/keysight250819kq/index",
    name: "keysight250819kq",
    component: (resolve) =>
      require(["@/act2025/keysight250819kq/index.vue"], resolve),
    meta: {
      title: "14比特示波器HD3，凭什么在电源测试九宫格中出圈？",
    },
  },
  // 小视频---q4---精测
  {
    path: "/keysight250819jc/index",
    name: "keysight250819jc",
    component: (resolve) =>
      require(["@/act2025/keysight250819jc/index.vue"], resolve),
    meta: {
      title: "14比特示波器HD3，凭什么在电源测试九宫格中出圈？",
    },
  },
  //   小视频----贝奇
  {
    path: "/keysight251117bq/index",
    name: "keysight251117bq",
    component: (resolve) =>
      require(["@/act2025/keysight251117bq/index.vue"], resolve),
    meta: {
      title: "EXR关于高速总线的协议测试和一致性测试分析",
    },
  },
];

export default Act2025;
